import { render, staticRenderFns } from "./LoadingData.vue?vue&type=template&id=4a669206&scoped=true"
import script from "./LoadingData.vue?vue&type=script&lang=js"
export * from "./LoadingData.vue?vue&type=script&lang=js"
import style0 from "./LoadingData.vue?vue&type=style&index=0&id=4a669206&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a669206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a669206')) {
      api.createRecord('4a669206', component.options)
    } else {
      api.reload('4a669206', component.options)
    }
    module.hot.accept("./LoadingData.vue?vue&type=template&id=4a669206&scoped=true", function () {
      api.rerender('4a669206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoadingData.vue"
export default component.exports